import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';

import {getMagazineCollectionCategory} from '@/services/magazine';
import ImageRail from '@/components/imageRail';

import styles from './styles.module.scss';

const KnewCategoryCollection = () => {
  const navigator = useNavigate();
  const [topic, setTopic] = useState<any[]>();

  const init = async () => {
    const {data} = await getMagazineCollectionCategory('');
    setTopic(data);
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <div className={styles.wrapper}>
      {topic &&
        topic.length > 0 &&
        topic.map((item, index) => {
          return (
            <div key={`item-${index}`}>
              <ImageRail
                title={item.title}
                titleStyle={{
                  padding: '0 20px',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                }}
                subtitle={item.subtitle}
                subtitleStyle={{margin: '8px 0 0 0'}}
                link={'/'}
                withTwoLineTitle
                disableDescription
                images={item?.magazines?.map((i: any) => {
                  return {
                    id: i.id,
                    url: i.imageUrl,
                    title: i.title,
                    description: i.subtitle,
                    price: i.price,
                    discountNumber: i.discountNumber,
                  };
                })}
                callbackItemClick={(item: any) => {
                  navigator(`/popup/${item.id}`, {
                    replace: true,
                  });
                }}
              />
            </div>
          );
        })}
    </div>
  );
};

export default KnewCategoryCollection;
